<template>
  <div class="data-grid-cascade"
       :class="{'main-top-layout': topComponent}"
       v-if="initialized">
    <transition name="animation-fade-switch"
                @after-enter="openedEvent"
                @after-leave="closedEvent">
      <div class="grid-cascade-pane"
           v-show="rendered">
        <div class="grid-cascade-cont">
          <div v-if="decoratorType"
               class="header"
               :class="'header-' + decoratorType">
            <slot name="header"
                  :title="title"
                  :content="content"
                  :back="hideCascade">
              <template v-if="decoratorType === 'nav-bar'">
                <NavBar :title="content"
                        border
                        @back="hideCascade"></NavBar>
              </template>
              <template v-else>
                <el-page-header class="theme-text"
                                :title="title || '返回上级'"
                                :content="content"
                                @back="hideCascade"></el-page-header>
              </template>
            </slot>
          </div>
          <div class="main-cont">
            <div class="slot-content">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import routeUtils from '../../../util/routeUtils'
import Support from '../../../mixins/support'
import PopperBus from '../../../mixins/popper/bus'
import PopperDecorator from '../../../mixins/popper/decorator'
import NavBar from '../../widgets/NavBar'
export default {
  name: 'DataGridCascade',
  mixins: [Support, PopperBus, PopperDecorator],
  components: {
    NavBar
  },
  props: {
    container: HTMLElement,
    title: String,
    content: String,
    visible: {
      type: Boolean,
      default: false
    }
  },
  provide () {
    return {
      $popper: this
    }
  },
  data () {
    return {
      initialized: false,
      rendered: false
    }
  },
  methods: {
    showCascade () {
      this.$emit('update:visible', true)
    },
    hideCascade () {
      this.$emit('update:visible', false)
    },
    toggleCascade () {
      this.$emit('update:visible', !this.visible)
    },
    initialCascade () {
      if (!this.initialized) {
        this.initialized = true
        this.$nextTick(() => {
          if (this.$el) {
            this.getCascadeContEl().appendChild(this.$el)
          }
          this.rendered = true
        })
      }
    },
    getCascadeContEl () {
      if (this.container) {
        return this.container
      } else {
        let match = routeUtils.getRouteComponent(this)
        if (match) {
          return match.$el
        }
        return document.body
      }
    }
  },
  mounted () {
    if (this.visible) {
      this.initialCascade()
    }
  },
  destroyed () {
    if (this.$el) {
      let parentNode = this.$el.parentNode
      if (parentNode) {
        parentNode.removeChild(this.$el)
      }
    }
  },
  watch: {
    visible: function (val) {
      if (val && !this.initialized) {
        this.initialCascade()
      } else {
        this.rendered = val
      }
      val ? this.openEvent() : this.closeEvent()
    }
  }
}
</script>

<style lang="scss">
  .data-grid-cascade {
    &.main-top-layout {
      & > .grid-cascade-pane {
        padding: 10px;
        & > .grid-cascade-cont {
          & > .header {
            & > .el-page-header {
              margin-top: 0;
            }
          }
        }
      }
    }
    & > .grid-cascade-pane {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: #f0f2f5;
      z-index: 2001;
      & > .grid-cascade-cont {
        position: relative;
        height: 100%;
        z-index: 100;
        display: flex;
        flex-direction: column;
        & > .header {
          flex: none;
          & > .el-page-header {
            height: 30px;
            line-height: 30px;
            margin-top: 10px;
            margin-bottom: 10px;
            .el-page-header__left {
              margin-right: 30px;
              &:after {
                right: -15px;
              }
              .el-page-header__title {
                font-size: 13px;
              }
            }
            .el-page-header__content {
              font-size: 14px;
            }
          }
          &-nav-bar {
            & ~ .main-cont {
              background-color: #fff;
            }
          }
        }
        & > .main-cont {
          flex: auto;
          position: relative;
          & > .slot-content {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
          }
        }
      }
    }
  }
  body {
    & > .data-grid-cascade {
      & > .grid-cascade-pane {
        z-index: 2099;
      }
    }
  }
</style>
